import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div className="entire">
      <div className="blogContainer ">
        <div className="col">
          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>Juno Solves 39-Year Old Mystery of Jupiter Lightning</h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>
                Engineers Solve Excessive Heat Removal from NASA’s Webb
                Telescope
              </h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>
                NASA Finds Ancient Organic Material, Mysterious Methane on Mars
              </h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>NASA to Host Live Discussion on New Mars Science Results</h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>20 Years of Earth Data Now at Your Fingertips</h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>Astronomers Spot a Distant and Lonely Neutron Star</h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>
                Astronauts Safely in Orbit Following Launch to International
                Space Station
              </h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>As Solar Wind Blows, Our Heliosphere Balloons</h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>

          <div className="blog-card-container">
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-overlay"></div>
            <div className="blog-card">
              <h4>
                Tiny Asteroid Discovered Saturday Disintegrates Hours Later Over
                Southern Africa
              </h4>
              <span className="chev">&rsaquo;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
